import styled from 'styled-components';
import { Col } from 'antd';

export const FormColumn = styled(Col)`
    display: flex;
    height: 100vh;
    align-items: center;
    justify-content: center;
`;
